import React, { useEffect, useState, useMemo } from 'react';
import { makeStyles, Spinner } from '@fluentui/react-components';
import { useTeamsContext } from '../../../providers/teams-context-provider';
import { useMsal } from '@azure/msal-react';
import { useSearchParams } from 'react-router-dom';
import { BASE_SCOPES } from '../../../constants/scopes';

const useStyles = makeStyles({
  containerStyle: {
    flex: 1,
    gap: '20px',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const AuthStart = () => {
  const styles = useStyles();
  const { instance } = useMsal();
  const { teamsContext } = useTeamsContext();
  const [initialized, setInitialized] = useState(false);
  const [searchParams] = useSearchParams();

  // Parse additional scopes from URL query parameter
  const additionalScopes = useMemo(() => {
    const scopesParam = searchParams.get('scopes');
    if (scopesParam) {
      return scopesParam.split(',').filter((s) => s.trim());
    }
    return [];
  }, [searchParams]);

  // Combine base scopes with additional scopes
  const allScopes = useMemo(() => {
    const scopes = [...BASE_SCOPES];
    for (const scope of additionalScopes) {
      if (!scopes.includes(scope)) {
        scopes.push(scope);
      }
    }
    return scopes;
  }, [additionalScopes]);

  useEffect(() => {
    if (initialized) {
      return;
    }

    if (!teamsContext) {
      return;
    }

    if (!teamsContext.user?.tenant) {
      return;
    }

    const loginHint = teamsContext.user.loginHint;

    console.log('Requesting consent for scopes:', allScopes);

    instance
      .initialize()
      .then(() =>
        instance.loginRedirect({
          scopes: allScopes,
          // Don't force prompt: 'consent' - let MSAL decide based on existing consent
          redirectUri: window.location.origin + `/auth-end`,
          loginHint: loginHint,
        })
      )
      .then(() => setInitialized(true));
  }, [instance, teamsContext, initialized, allScopes]);

  return (
    <div className={styles.containerStyle}>
      <Spinner label="Redirection..." size="large" />
    </div>
  );
};
